{
    "table_header__product_name": "Product",
    "table_header__quote_id": "Quote ID",
    "table_header__order_id": "Order ID",
    "table_header__customer_id": "Customer ID",
    "table_header__quote_created": "Date",
    "table_header__valid_until": "Valid until",
    "table_header__offer": "Offer",
    "table_header__status": "Status",
    "table_header__order_date": "Date",
    "table_header__location": "Location",
    "table_header__customer": "Customer",
    "table_header__total": "Total",
    "table_header__margin": "GM",
    "table_header__lines": "Lines",
    "table_header__quantity": "Quantity",
    "table_header__sales_rep": "Sales Rep",
    "table_header__unit": "Unit",
    "table_header__price": "Price",
    "table_header__clerk": "Clerk"
}
